import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { INewbuilding } from '../../types/newbuilding/newbuilding';
import { IOrderStatusSchema } from '../../repositories/newbuilding-card/entities/flat_view_order/OrderStatusSchema';

export enum ENewbuildingActionTypes {
  SetNewbuilding = 'newbuilding/set',
  SetFlatViewOrder = 'newbuilding/setFlatViewOrder',
}

// Warning флаг isFavorite нужен только при инициализации, в дальнейшнем он меняется в FavoriteBasic
export type TSetNewbuilding = ITypedReduxAction<ENewbuildingActionTypes.SetNewbuilding, INewbuilding>;

export type TSetFlatViewOrder = ITypedReduxAction<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatusSchema>;

/**
 * Redux action, который записывает в store фичи
 * @param features IConfigFeatures
 */
export const setNewbuilding: (newbuilding: INewbuilding) => TSetNewbuilding = actionGenerator<
  ENewbuildingActionTypes.SetNewbuilding,
  INewbuilding
>(ENewbuildingActionTypes.SetNewbuilding);

export const setFlatViewOrder = actionGenerator<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatusSchema>(
  ENewbuildingActionTypes.SetFlatViewOrder,
);
